import { createSlice, PayloadAction } from '@reduxjs/toolkit';

type Severity = 'success' | 'error' | 'info' | 'warn';

interface NotificationState {
  message: string;
  severity: Severity;
  key: number; // A key to trigger re-renders
  life?: number;
}

const initialState: NotificationState = {
  message: '',
  severity: 'info',
  key: 0,
  life: undefined,
};

const notificationSlice = createSlice({
  name: 'notification',
  initialState,
  reducers: {
    showNotification: (
      state,
      action: PayloadAction<{ message: string; severity: Severity; life?: number }>,
    ) => {
      state.message = action.payload.message;
      state.severity = action.payload.severity;
      state.life = action.payload.life;
      state.key = Date.now();
    },
    clearNotification: (state) => {
      state.message = '';
      state.key = 0;
      state.life = undefined;
    },
  },
});

export const { showNotification, clearNotification } = notificationSlice.actions;
export default notificationSlice.reducer;
